const isValidAkey = (val) => {
	const regexp = /^[0-9a-z]{32}$/;
	return regexp.test(val);
};

// cookieDomain を設定するシングルトン関数。setter / getter
export const cookieDomain = (() => {
	let _value = "weathernews.jp";
	return {
		get value () {
			return _value;
		},
		set value (d) {
			_value = d;
		},
	};
})();

export const getAkeyV3 = () => {
	const params = new URLSearchParams(location.search);
	const cookies = readCookie();

	let akey = params.get("akey");
	if (!isValidAkey(akey)) akey = params.get("id");
	if (!isValidAkey(akey)) akey = cookies.akey;
	if (!isValidAkey(akey)) akey = cookies.id;
	if (!isValidAkey(akey)) akey = params.get("mdbauth");
	if (!isValidAkey(akey)) akey = cookies.mdbauth;
	if (!isValidAkey(akey)) akey = "";

	return akey;
};

export const getSmartPlatform = (userAgent) => {
	const ua = userAgent || navigator.userAgent;
	return ua.match(/Android/)
		? "android"
		: ua.match(/iPhone|iPad|iPod/)
			? "iOS"
			: "";
};

export const isWebview = (userAgent) => {
	const ua = userAgent || navigator.userAgent;
	return getSmartWebview(ua) === "webview";
};

export const getSmartWebview = (userAgent) => {
	const ua = userAgent || navigator.userAgent;
	if (ua.indexOf("weathernews") >= 0) {
		return "webview";
	}
	const smartPlatform = getSmartPlatform(ua);
	if (smartPlatform === "android" && window.wni) {
		return "webview";
	}
	if (smartPlatform) {
		return "browser";
	}
};

export const readCookie = () => {
    const cookies = {}
	const p = document.cookie.split("; ");
	for (let i = 0; i < p.length; i++) {
		const kv = p[i].split("=");
		cookies[kv[0]] = kv[1];
	}
	return cookies;
};

const COOKIE_DAYS = {
	lat: 1 / 48,
	lon: 1 / 48,
};

export const cookieWrite = (key, val, days) => {
	const t = new Date();
	const expireDays = days || COOKIE_DAYS[key] || 366;
	t.setTime(t.getTime() + 86400000 * expireDays);
	document.cookie = `${key}=${val}; expires=${t.toGMTString()}; domain=${cookieDomain.value}; path=/; `;
};

export const cookieRemove = (key) => {
	cookieWrite(key, "", -1);
};

export const nocache = Math.floor(Date.now() / 60000);

export const isValidValue = (val) => {
	return (
		val !== "" &&
		val !== undefined &&
		val !== "undefined" &&
		val !== null &&
		val !== "null" &&
		val !== "(null)"
	);
};

export const getParamsOrCookie = (key) => {
	const params = new URLSearchParams(location.search);
	const cookies = readCookie();
	return params.get(key) || cookies[key];
};

export const readParams = (() => {
	const cache = {};
	return (forceFlag) => {
		if (!forceFlag && Object.keys(cache).length) {
			return cache;
		}

		const params = new URLSearchParams(location.search);
		for (const [key, val] of params) {
			cache[key] = val;
		}
		return cache;
	};
})();

export const readArgv = () => {
	const argv = {};
	const cookies = readCookie();
	for (const key in cookies) {
		argv[key] = cookies[key];
	}
	const params = readParams();
	for (const key in params) {
		argv[key] = params[key];
	}

	return argv;
};

/**
 * 与えられたデータからアプリのバージョンを抜き出す関数
 * @param {Object} argv - versionを取得したいデータ
 * @returns {String} version
 * @function
 */
export const getVersion = (argv) => {
	const params = new URLSearchParams(argv || readArgv());
	const ver = params.get("ver");
	const v = params.get("v");

	const version = isValidValue(ver) ? ver : isValidValue(v) ? v : "";
	return String(version).replace(/^ver\./, "");
};

/**
 * バージョン情報を比較する関数
 * @param {String} myVersion - 比較したいバージョン（主に自信が持つバージョン）
 * @param {String} targetVersion - 比較したいバージョン（主に機能制限があるバージョン）
 * @returns {Number} - 0: バージョンが同じ, -1: バージョンが低い, 1: バージョンが高い
 * @example
 * var comp = wniutil.comp_version('4.10.0', '4.9.3');
 * // return 1
 * @function
 */

export const compareVersion = (myVersion, targetVersion) => {
	if (!myVersion || !targetVersion) return 0;
	if (myVersion === targetVersion) return 0;

	const v1 = myVersion.replace(/[^0-9.-]/g, "").replace(/^\./, "");
	const v2 = targetVersion.replace(/[^0-9.-]/g, "").replace(/^\./, "");

	const v1Ary = v1.split(".");
	const v2Ary = v2.split(".");

	const l = Math.max(v1Ary.length, v2Ary.length);
	for (let i = 0; i < l; i++) {
		let v1Val = Number.parseInt(v1Ary[i], 10);
		let v2Val = Number.parseInt(v2Ary[i], 10);
		if (!v1Val) v1Val = 0;
		if (!v2Val) v2Val = 0;

		if (v1Val > v2Val) return 1;
		if (v1Val < v2Val) return -1;
	}

	return 0;
};

export class AppVersion {
	constructor(version) {
		if (typeof version === "string") {
			this.version = version;
		} else {
			this.version = getVersion();
		}
	}

	get() {
		return this.version;
	}

	/**
	 * @param {String} v2 compare version
	 * @param {Boolean} includeSameVersion 
	 * @returns 
	 */
	isAfter(v2, includeSameVersion) {
		return compareVersion(this.version, v2) >= (includeSameVersion ? 0 : 1);
	}

	/**
	 * @param {String} v2 compare version
	 * @param {Boolean} includeSameVersion 
	 * @returns 
	 */
	isBefore(v2, includeSameVersion) {
		return compareVersion(this.version, v2) <= (includeSameVersion ? 0 : -1);
	}

	/**
	 * @param {String} v2 compare version
	 * @returns 
	 */
	isEqual(v2) {
		return compareVersion(this.version, v2) === 0;
	}
}

/**
 * スゴ得アプリかどうかを判定する関数
 * @param {String} [ua=navigator.userAgent] - UserAgent
 * @returns {Boolean}
 * @function
 */
export const isSugotokuApp = (userAgent) => {
	const ua = userAgent || navigator.userAgent;
	return RegExp(/\ market\/\(sugotoku\)/).test(ua);
};

/**
 * auマーケット版アプリかどうかを判定する関数
 * @param {String} [ua=navigator.userAgent] - UserAgent
 * @returns {Boolean}
 * @function
 */
export const isAumarketApp = (userAgent) => {
	const ua = userAgent || navigator.userAgent;
	const marketCheck = RegExp(/\ market\/\((.+?)\)/).exec(ua);
	if (marketCheck) {
		return marketCheck[1] === "au_market";
	}
	return RegExp(/\ weathernews\/?\(.+?\/a.+?\)/).test(ua);
};

/**
 * app pass版アプリかどうかを判定する関数
 * @param {String} [ua=navigator.userAgent] - UserAgent
 * @returns {Boolean}
 * @function
 */
export const isApppassApp = (userAgent) => {
	const ua = userAgent || navigator.userAgent;
	return RegExp(/\ market\/\(app_pass\)/).test(ua);
};

/**
 * smartpass版アプリかどうかを判定する関数
 * @param {String} [ua=navigator.userAgent] - UserAgent
 * @returns {Boolean}
 * @function
 */
export const isSmartpassApp = (userAgent) => {
	const ua = userAgent || navigator.userAgent;
	return RegExp(/spass-app/).test(ua);
};

/**
 * ウェザーニュースアプリかどうかを判定する関数
 * @param {String} [ua=navigator.userAgent] - UserAgent
 * @returns {Boolean}
 * @function
 */
export const isWniApp = (userAgent) => {
	const ua = userAgent || navigator.userAgent;
	return RegExp(/weathernews/).test(ua);
};

/**
 * リファラーを見て、weathernews内の回遊か否かを判定する関数
 * @param {String} [ref=document.referrer] - referrer
 * @returns {Boolean}
 * @function
 */
export const isFromOutside = (referrer) => {
	const ref = referrer || document.referrer;

	if (!RegExp(/^http/).test(ref)) return true;
	const domainCheck = RegExp(/https?:\/\/(.+?)(\/|\?|$)/).exec(ref);
	if (
		domainCheck &&
		RegExp(/weathernews|\.wni\.co\.jp$|wni\.jp$|wni\.me$/).test(domainCheck[1])
	) {
		return false;
	}
	return true;
};

export const snakeToCamel = (str) => {
	return str.replace(/_./g, (s) => s.charAt(1).toUpperCase());
};

/**
 * 要素が表示されているかどうかを判定する関数
 * @param {HTMLElement} el 
 * @returns {Boolean}
 */
export const isVisibleElement = (el) => {
	if (!el) return false;
	try {
		let count = 0
		for (let e = el; e; e = e.parentElement) {
			const style = window.getComputedStyle(e);
			if (style.display === "none") return false;
			if (style.visibility === "hidden") return false;
			count += 1;
			if (count > 5) break; // 5階層以上は無視
		}
	} catch (e) {
		return false;
	}

	return true
}
